<div
  [ngClass]="{ 'has-background': hasBackground(), 'h-100': height100(), 'no-box-shadow': noBoxShadow() }"
  class="card-basic {{ cardClass() }}"
>
  @if (hasBackground()) {
    <div class="card-background"></div>
  }
  <div class="card-basic-body" data-test="basic-card-body">
    @if (cardTitle()) {
      <mwe-basic-card-title
        [cardTitleParams]="cardTitleParams()"
        [cardTitle]="cardTitle()"
        [headingNodeType]="headingNodeType()"
        [iconClass]="iconClass()"
        data-test="basic-card-title"
      />
    }
    <ng-content />
  </div>
  @if (optionalLastChildClass()) {
    <div class="{{ optionalLastChildClass() }}"></div>
  }
</div>
